import React from 'react';

import type { Asset } from '@/types';

interface AssetRiskScoreCellProps {
  asset: Asset;
}

export const AssetRiskScoreCell: React.FC<AssetRiskScoreCellProps> = ({
  asset,
}) => {
  if (typeof asset.riskScore !== 'number') {
    return <span className="text-chariot-text-secondary">-</span>;
  }
  return <span className="tabular-nums">{asset.riskScore}</span>;
};
